var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider } from 'react-i18next';
import { FlagsProvider } from 'flagged';
import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { useCreditAccountsQuery } from 'syf-api';
import 'wicg-inert';
import { activityConfig } from '../../const/activity-config';
import { ActivityProvider } from '../../context/activity-store';
import useActivityData from '../../hooks/use-activity-data';
import useServiceFileQuery from '../../services/use-service-file';
import i18n from '../../strings/i18n';
import theme from '../../styles/theme';
import Main from './main';
import { Platform } from '../../services/mma-config';
var ActivityRoot = function (_a) {
    var _b, _c, _d;
    var className = _a.className, _e = _a.config, config = _e === void 0 ? activityConfig : _e, _f = _a.display, display = _f === void 0 ? 'full' : _f, _g = _a.platform, platform = _g === void 0 ? Platform.VISTA : _g, guidAccountId = _a.guidAccountId, navigationHandler = _a.navigationHandler, totalTransactions = _a.totalTransactions;
    var languageInStorage = localStorage.getItem('language');
    var serviceFilerQueryArgs = {
        path: '',
        config: config,
        queryOptions: {
            retry: false
        }
    };
    var creditAccountQueryEnabled = guidAccountId === undefined;
    var creditAccountQueryArgs = {
        config: config,
        keyProps: undefined,
        queryOptions: {
            enabled: creditAccountQueryEnabled,
            staleTime: Infinity
        }
    };
    var serviceFileData = useServiceFileQuery(serviceFilerQueryArgs).data;
    var _h = useCreditAccountsQuery(creditAccountQueryArgs), creditAccounts = _h.data, isCreditFetching = _h.isFetching;
    var creditInfo = (_c = (_b = creditAccounts === null || creditAccounts === void 0 ? void 0 : creditAccounts.accounts) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.info;
    var accountIdType = guidAccountId
        ? 'guid'
        : creditInfo === null || creditInfo === void 0 ? void 0 : creditInfo.accountIdType;
    var accountId = guidAccountId !== null && guidAccountId !== void 0 ? guidAccountId : creditInfo === null || creditInfo === void 0 ? void 0 : creditInfo['cipher.accountId'];
    var isDisplayCondensed = display === 'condensed';
    var _j = useActivityData({
        accountId: accountId,
        accountIdType: accountIdType,
        config: config,
        isDisplayCondensed: isDisplayCondensed
    }), activity = _j.activity, isError = _j.isError, isFetching = _j.isFetching, isSuccess = _j.isSuccess, refetchAccountActivity = _j.refetchAccountActivity, showLoadMore = _j.showLoadMore;
    var fetching = isFetching !== null && isFetching !== void 0 ? isFetching : isCreditFetching;
    useEffect(function () {
        if (className) {
            document.body.classList.add(className);
        }
    }, [className]);
    useEffect(function () {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(function (error) { return error; });
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [languageInStorage]);
    return (_jsx(FlagsProvider, { features: (_d = serviceFileData === null || serviceFileData === void 0 ? void 0 : serviceFileData.config) === null || _d === void 0 ? void 0 : _d.flags, children: _jsx(Main, { accountId: accountId, accountIdType: accountIdType, activity: activity, config: config, isError: isError, isFetching: fetching, isSuccess: isSuccess, refetchAccountActivity: refetchAccountActivity, totalTransactions: totalTransactions !== null && totalTransactions !== void 0 ? totalTransactions : '10', isDisplayCondensed: isDisplayCondensed, showLoadMore: showLoadMore, handleNavigate: navigationHandler, platform: platform }) }));
};
var ActivityEntry = function (props) {
    return (_jsx(I18nextProvider, { i18n: i18n, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(ActivityProvider, { children: _jsx(ActivityRoot, __assign({}, props)) }) }) }));
};
export default ActivityEntry;
//# sourceMappingURL=index.js.map